import { render, staticRenderFns } from "./AddMapping.vue?vue&type=template&id=1f82c16e&scoped=true"
import script from "./AddMapping.vue?vue&type=script&lang=js"
export * from "./AddMapping.vue?vue&type=script&lang=js"
import style0 from "./AddMapping.vue?vue&type=style&index=0&id=1f82c16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82c16e",
  null
  
)

export default component.exports